
export const formatFraction = (value: number): string => {
  // Common fractions to maintain
  const fractions: Record<number, string> = {
    0.25: '1/4',
    0.5: '1/2',
    0.75: '3/4',
    0.33: '1/3',
    0.67: '2/3',
    0.2: '1/5',
    0.4: '2/5',
    0.6: '3/5',
    0.8: '4/5'
  };

  const closest = Object.entries(fractions).reduce((prev, [decimal, fraction]) => {
    return Math.abs(Number(decimal) - value) < Math.abs(Number(prev[0]) - value) ? [decimal, fraction] : prev;
  });

  if (Math.abs(Number(closest[0]) - value) < 0.01) {
    return closest[1];
  }

  return value.toFixed(2).replace(/\.?0+$/, '');
};

export const findAmount = (ingredient: string): { amount: string; unit: string; originalAmount: string } | null => {
  const match = ingredient.match(/(\d+(?:\/\d+)?|\d*\.?\d+)\s*(cup|cups|tablespoon|tablespoons|tbsp|teaspoon|teaspoons|tsp|oz|ounce|ounces|pound|pounds|gram|grams|g)s?\b/i);
  if (!match) return null;
  
  const [_, amount, unit] = match;
  let numericAmount: string;
  
  if (amount.includes('/')) {
    const [num, denom] = amount.split('/');
    numericAmount = String(Number(num) / Number(denom));
  } else {
    numericAmount = amount;
  }

  return { 
    amount: numericAmount,
    unit,
    originalAmount: amount
  };
};

export const standardizeUnit = (unit: string): string => {
  const unitMap: Record<string, string> = {
    'tablespoon': 'tbsp',
    'tablespoons': 'tbsp',
    'tbsp': 'tbsp',
    'teaspoon': 'tsp',
    'teaspoons': 'tsp',
    'tsp': 'tsp',
    'cup': 'cup',
    'cups': 'cup',
    'ounce': 'oz',
    'ounces': 'oz',
    'oz': 'oz',
    'pound': 'lb',
    'pounds': 'lb',
    'gram': 'g',
    'grams': 'g',
    'g': 'g'
  };
  return unitMap[unit.toLowerCase()] || unit;
};
